<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="用户"
      edit-title
      id-key="UserId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @closed="isEdit = false"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="用户姓名" prop="TeacherId">
          <!-- <select-input
            placeholder="选择人员"
            :label="data.EmpName"
            v-model="data.EmpId"
            @click="openEmpDialog"
          />-->
          <el-input
            size="mini"
            v-model="data.TeacherName"
            @focus="onTeacherDialog"
            readonly
            placeholder="点击选择"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户账号" prop="LoginId">
          <el-input v-model="data.LoginId" placeholder="请输入用户账号"></el-input>
        </el-form-item>
        <el-form-item label="初始密码" prop="Pwd" :rules="isEdit?null:pwdRules.Pwd">
          <el-input
            show-password
            type="password"
            v-model="data.Pwd"
            :placeholder="isEdit ? '如无需改动可不填':'请输入用户密码'"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属角色" prop="RoleId">
          <role-select v-model="data.RoleId" ref="roleSelect"></role-select>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <!-- <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" /> -->
      <teacher-dialog
        ref="teacherDialog"
        in-dialog
        selectable
        :multiple="false"
        @select="setTeacher"
      />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import roleSelect from "@/components/sys/role/select";
import teacherDialog from "@/components/sys/teacher/listDialog";
// import empDialog from "@/components/ent/emp/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    roleSelect,
    teacherDialog,
    // empDialog,
  },
  data() {
    let validator = (rule, value, callback) => {
      if (value.length != 0) {
        if (value.length < 6) {
          callback("密码不能小于六位");
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      data: {
        UserId: 0,
        TeacherId: null,
        TeacherName: "",
        TeacherNumber: "",
        PhoneNumber: "",
        // EmpId: 0,
        // EmpName: "",
        // EmpNo: "",
        LoginId: "",
        Status: 1,
        RoleId: null,
        RoleName: "",
        Pwd: "",
        // DpId: 0,
        // DpName: "",
      },
      isEdit: false,
      api: require("@/api/sy/user").default,
      rules: {
        TeacherId: [{ required: true, message: "请选择人员" }],
        LoginId: [{ required: true, message: "登录账号不能为空" }],
        RoleId: [{ required: true, message: "请选择所属角色" }],
        Pwd: [{ validator: validator }],
      },
      pwdRules: {
        Pwd: [
          { required: true, message: "初始密码不能为空" },
          { validator: this.$commonJs.validateRules.validPwd },
          { validator: validator },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      this.isEdit = true;
      this.data.Pwd = "";
    },
    onTeacherDialog() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    setTeacher(t) {
      this.data.TeacherId = t.TeacherId;
      this.data.TeacherName = t.TeacherName;
      this.data.TeacherNumber = t.TeacherNumber;
      this.data.PhoneNumber = t.PhoneNumber;
    },
    // openEmpDialog() {
    //   this.$refs.empDialog.open().then((that) => {
    //     that.getData();
    //   });
    // },
    // setEmp(emp) {
    //   console.log(emp);
    //   this.data.EmpId = emp.EmpId;
    //   this.data.EmpName = emp.EmpName;
    //   this.data.EmpNo = emp.EmpNo;
    //   this.data.DpId = emp.DpId;
    //   this.data.DpName = emp.DpName;
    // },
  },
};
</script>